<template>
	<div>
		<!-- 轮播图 -->
		<el-carousel height="398px">
		  <el-carousel-item v-for="(item, index) in bannerList" :key="index">
		    <img style="width: 100%;height: 100%;" :src="item"/>
		  </el-carousel-item>
		</el-carousel>
		
		<!-- 国际海运 -->
		<div class="container">
			<div class="content" style="padding-top: 100px;padding-bottom: 50px;">
				<div style="font-size: 28px;margin-bottom: 70px;text-align: center;">国际海运</div>
				<div style="display: flex;justify-content: space-between;align-items: center;">
					<div style="line-height: 1.75;font-size: 16px;color: #444;width: 345px;">中雅国际拥有10年进出口专业国际海运专线整柜/拼柜一站式服务，根据客户的不同需求，通过定制化的创新为各行业客户提供世界各地海运整柜及拼柜一条龙服务，包括上门收货、保价运输、安全包装、包清送等一体化服务。中雅国际海运业务主要以上海浦东、宁波等华东港口为依托，与YML、HMM、HPL、ONE、CMA、MSC、MSK、ZIM、COSCO、OOCL、EMC等船公司及其代理保持密切的合作关系，提供专业个性化的国际海运代理运输服务。</div>
					<div style="display: flex;justify-content: space-between;flex-wrap: wrap;width: calc(100% - 375px);">
						<div class="hover-image-box" v-for="(item, index) in routeImages" style="width: 261px;overflow: hidden;height: 156px;cursor: pointer;" :style="index == 0 ? {marginBottom: '20px'} : {}">
							<img :src="item" style="width: 100%;transition: all 0.3s;"/>
						</div>
					</div>
				</div>
			</div>
		</div>
		
		<!-- 海运流程图 -->
		<div class="container">
			<div class="content" style="padding-bottom: 50px;">
				<img src="https://shop-1319179580.cos.accelerate.myqcloud.com/2024/08/10/1006178082416.jpg" style="width: 100%;"/>
			</div>
		</div>
		
		
		
	</div>
</template>

<script>

export default {
	data() {
		return {
			bannerList: ['https://shop-1319179580.cos.accelerate.myqcloud.com/2024/08/10/100617808241.jpg'],
			routeImages: [
				'https://shop-1319179580.cos.accelerate.myqcloud.com/2024/08/10/100240103973.png', 
				'https://shop-1319179580.cos.accelerate.myqcloud.com/2024/08/10/100240103974.png', 
				'https://shop-1319179580.cos.accelerate.myqcloud.com/2024/08/10/100240103971.png', 
				'https://shop-1319179580.cos.accelerate.myqcloud.com/2024/08/10/100240103972.png', 
				'https://shop-1319179580.cos.accelerate.myqcloud.com/2024/08/10/100240103976.png', 
				'https://shop-1319179580.cos.accelerate.myqcloud.com/2024/08/10/100240103975.png'
			]
		}
	},
}
</script>

<style>
	
</style>


// WEBPACK FOOTER //
// src/components/shipping.vue